document.addEventListener("DOMContentLoaded", function(){

  const searchInput = document.getElementById("brandSearch");
  const brands = document.querySelectorAll(".brand-item");

  searchInput.addEventListener("input", function(){

    const searchValue = this.value.toLowerCase();

    brands.forEach(function(brand){

      const brandName = brand.textContent.toLowerCase();

      if(brandName.includes(searchValue)){
        brand.style.display = "";
      } else {
        brand.style.display = "none";
      }

    });

  });

});
